import {
  MessageSquare,
  FileText,
  Image as ImageIcon,
  Paperclip,
} from "lucide-react";

export const getCategoryColor = (category) => {
  const colors = {
    geral: "bg-gray-100 text-gray-800",
    saudacao: "bg-blue-100 text-blue-800",
    despedida: "bg-purple-100 text-purple-800",
    vendas: "bg-green-100 text-green-800",
    suporte: "bg-yellow-100 text-yellow-800",
    agradecimento: "bg-pink-100 text-pink-800",
    confirmacao: "bg-indigo-100 text-indigo-800",
    promocao: "bg-red-100 text-red-800",
  };
  return colors[category] || "bg-gray-100 text-gray-800";
};

export const getTypeIcon = (type) => {
  const icons = {
    text: <MessageSquare className="h-4 w-4" />,
    image: <ImageIcon className="h-4 w-4" />,
    document: <FileText className="h-4 w-4" />,
    audio: <Paperclip className="h-4 w-4" />,
    video: <Paperclip className="h-4 w-4" />,
  };
  return icons[type] || <MessageSquare className="h-4 w-4" />;
};

export const getMessageDate = (dateString) => {
  const date = new Date(dateString);
  return date.toLocaleDateString("pt-BR", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  });
};

export const normalizeText = (text) => {
  if (!text) return "";

  return text
    .replace(/\r\n/g, "\n")
    .replace(/[ \t]+\n/g, "\n")
    .replace(/\n{3,}/g, "\n\n")
    .trim();
};

export const formatText = (text) => {
  return text.replace(/\*(.*?)\*/g, "$1");
};
